import classNames from 'classnames'
import Dialog from 'lib/components/Dialog/Dialog'
import React, { ReactNode } from 'react'

export interface ActionDialogFooterProps {
  children: ReactNode
  className?: string
}

export default function ActionDialogFooter(props: ActionDialogFooterProps) {
  const { children, className, ...otherProps } = props
  const mergedClassName = classNames('admin-action-dialog__footer', className)

  return (
    <Dialog.Footer className={mergedClassName} {...otherProps}>
      {children}
    </Dialog.Footer>
  )
}
